import axios from "axios";
import store from "../store";

let requests = [];

const whitelist = [];

let api = null;

export default () => {
  if (!api) {
    api = axios.create({
      baseURL: store.state.enderecoAPI,
      headers: {
        Usuario: store.state.usuario,
        Senha: store.state.password,
        Empresa: store.state.empresa
      }
    });

    api.interceptors.request.use(config => {
      // console.log("requesting", config.url, "on", requests);
      if (whitelist.some(el => config.url.includes(el))) return config;
      if (requests.some(el => el === config.url)) return Promise.reject();

      requests.push(config.url);
      return config;
    });

    api.interceptors.response.use(response => {
      // console.log("removing", response.config.url, "from", requests);
      requests = requests.filter(el => el !== response.config.url);
      return response;
    });
  }

  return api;
};
